import { maxHeight, maxWidth } from "@mui/system"; 
import NavBar from "./NavBar";
import { Eye, Clock, Image, Settings } from "lucide-react";
import { useState, useEffect } from "react";
import React from "react";
import "../styling/Certifications.css";

const Certificates = () => {
  const certificates = [
    {
      id: 1,
      img: "https://i.imghippo.com/files/wSQ8810UPA.jpg", 
      title: "Huawei HCSA-Field-Access",
      university: "Huawei",
      link:"https://i.imghippo.com/files/wSQ8810UPA.jpg"
    },
    
  ];

  return (
    <>
      

      <NavBar
        links={[
          { type: "anchor", label: "Home", href: "/" },
          { type: "anchor", label: "About", href: "/" },
          { type: "anchor", label: "Certifications", href: "/Certifications" },
          { type: "anchor", label: "Experience", href: "/" },
          { type: "anchor", label: "Services", href: "/" },
          {
            type: "anchor",
            label: "Projects",
            href: "/",
            children: [
              { type: "anchor", label: "Dev Projects", href: "/DevProjects" },
              { type: "anchor", label: "IT Projects", href: "/ItProjects" },
            ],
          },
          { type: "anchor", label: "Products", href: "/Products" },
          { type: "anchor", label: "Contact", href: "/" },
        ]}
      />

      <h1
        style={{
          backgroundColor: "#0A192F",
          margin: 0,
          padding: 0,
          height: "70px",
        }}
      >
        {" "}
      </h1>

         <section className="certificates-section">
      <div className="certificates-text">
        <h3 className="highlight">Check Out</h3>
        <h2 className="title">MY CERTIFICATES</h2>
        
        
      </div>

      <div className="certificates-grid">
        {certificates.map((cert) => (
          <div key={cert.id} className="certificate-card">
            <img src={cert.img} alt={cert.title} />
            <h4>{cert.title}</h4>
            <p>{cert.university}</p>
            <a href={cert.link}>
            <button className="btn-know-more">View</button>
            </a>
            

          </div>
        ))}
      </div>
    </section>
      
    </>
    
  );
};

export default Certificates;
